
/* Model */
class SkuModel extends App.Models.BaseModel {
    modelUrl = 'Sku';
}

App.Models.Sku = SkuModel;

/* Collection */
class SkuCollection extends App.Collections.BaseCollection {
    url = 'Sku';
    model = App.Models.Sku;
}

App.Collections.Skus = SkuCollection;

/* Router */
class SkuRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'Sku';
        const model = App.Models.Sku;
        const collectionClass = App.Collections.Skus;

        super(entityName, model, collectionClass);
    }
}

App.Routers.Sku = SkuRouter;
